import { render, staticRenderFns } from "./Otros-enlaces.vue?vue&type=template&id=f43b23f0&scoped=true"
var script = {}
import style0 from "./Otros-enlaces.vue?vue&type=style&index=0&id=f43b23f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f43b23f0",
  null
  
)

export default component.exports